module.exports = __webpack_public_path__ + "img/imageclose2.8a1203c4.svg";